import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { getToken } from '@/shared/api/interceptors';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

type CreateAccountParams = {
  email?: string;
  referral?: string;
};

const createAccount = async ({ email, referral }: CreateAccountParams) => {
  const token = (await getToken()) as string;

  return API.createAccount({ email, referral_id: referral || '', token });
};

export const useCreateAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAccount,
    onSuccess: (user) => {
      queryClient.setQueryData(USER_QUERY_KEYS.account, user);
    },
  });
};
